// @ts-nocheck
import { IDraggableConfig } from 'Components/Atoms'
import { Option } from '.'

export const OptionDraggable = (draggableConfig: IDraggableConfig) => {
  return <Option presenter={draggableConfig.presenter} />
}
